const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
const USER_LOGOUT = 'USER_LOGOUT';

const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';

const LIKE_ADD_VIDEO_REQUEST = 'LIKE_ADD_VIDEO_REQUEST';
const LIKE_ADD_VIDEO_SUCCESS = 'LIKE_ADD_VIDEO_SUCCESS';
const LIKE_ADD_VIDEO_FAIL = 'LIKE_ADD_VIDEO_FAIL';

const LIKE_REMOVE_VIDEO_REQUEST = 'LIKE_REMOVE_VIDEO_REQUEST';
const LIKE_REMOVE_VIDEO_SUCCESS = 'LIKE_REMOVE_VIDEO_SUCCESS';
const LIKE_REMOVE_VIDEO_FAIL = 'LIKE_REMOVE_VIDEO_FAIL';

const LIKES_REQUEST = 'LIKES_REQUEST';
const LIKES_SUCCESS = 'LIKES_SUCCESS';
const LIKES_FAIL = 'LIKES_FAIL';

const WATCHLATER_ADD_VIDEO_REQUEST = 'WATCHLATER_ADD_VIDEO_REQUEST';
const WATCHLATER_ADD_VIDEO_SUCCESS = 'WATCHLATER_ADD_VIDEO_SUCCESS';
const WATCHLATER_ADD_VIDEO_FAIL = 'WATCHLATER_ADD_VIDEO_FAIL';

const WATCHLATER_REMOVE_VIDEO_REQUEST = 'WATCHLATER_REMOVE_VIDEO_REQUEST';
const WATCHLATER_REMOVE_VIDEO_SUCCESS = 'WATCHLATER_REMOVE_VIDEO_SUCCESS';
const WATCHLATER_REMOVE_VIDEO_FAIL = 'WATCHLATER_REMOVE_VIDEO_FAIL';

const WATCHLATER_REQUEST = 'WATCHLATER_REQUEST';
const WATCHLATER_SUCCESS = 'WATCHLATER_SUCCESS';
const WATCHLATER_FAIL = 'WATCHLATER_FAIL';

const HISTORY_REQUEST = 'HISTORY_REQUEST';
const HISTORY_SUCCESS = 'HISTORY_SUCCESS';
const HISTORY_FAIL = 'HISTORY_FAIL';

const CLEAR_HISTORY_REQUEST = 'CLEAR_HISTORY_REQUEST';
const CLEAR_HISTORY_SUCCESS = 'CLEAR_HISTORY_SUCCESS';
const CLEAR_HISTORY_FAIL = 'CLEAR_HISTORY_FAIL';

const HISTORY_ADD_VIDEO_REQUEST = 'HISTORY_ADD_VIDEO_REQUEST';
const HISTORY_ADD_VIDEO_SUCCESS = 'HISTORY_ADD_VIDEO_SUCCESS';
const HISTORY_ADD_VIDEO_FAIL = 'HISTORY_ADD_VIDEO_FAIL';

const HISTORY_REMOVE_VIDEO_REQUEST = 'HISTORY_REMOVE_VIDEO_REQUEST';
const HISTORY_REMOVE_VIDEO_SUCCESS = 'HISTORY_REMOVE_VIDEO_SUCCESS';
const HISTORY_REMOVE_VIDEO_FAIL = 'HISTORY_REMOVE_VIDEO_FAIL';

const GET_PLAYLISTS_REQUEST = 'GET_pLAYLISTS_REQUEST';
const GET_PLAYLISTS_SUCCESS = 'GET_pLAYLISTS_SUCCESS';
const GET_PLAYLISTS_FAIL = 'GET_pLAYLISTS_FAIL';

const CREATE_PLAYLIST_REQUEST = 'CREATE_PLAYLIST_REQUEST';
const CREATE_PLAYLIST_SUCCESS = 'CREATE_PLAYLIST_SUCCESS';
const CREATE_PLAYLIST_FAIL = 'CREATE_PLAYLIST_REQUEST';

const DELETE_PLAYLIST_REQUEST = 'DELETE_PLAYLIST_REQUEST';
const DELETE_PLAYLIST_SUCCESS = 'DELETE_PLAYLIST_SUCCESS';
const DELETE_PLAYLIST_FAIL = 'DELETE_PLAYLIST_REQUEST';

const GET_PLAYLIST_DETAILS_REQUEST = 'GET_PLAYLIST_DETAILS_REQUEST';
const GET_PLAYLIST_DETAILS_SUCCESS = 'GET_PLAYLIST_DETAILS_SUCCESS';
const GET_PLAYLIST_DETAILS_FAIL = 'GET_PLAYLIST_DETAILS_FAIL';

const ADD_TO_PLAYLIST_REQUEST = 'ADD_TO_PLAYLIST_REQUEST';
const ADD_TO_PLAYLIST_SUCCESS = 'ADD_TO_PLAYLIST_SUCCESS';
const ADD_TO_PLAYLIST_FAIL = 'ADD_TO_PLAYLIST_FAIL';

const REMOVE_FROM_PLAYLIST_REQUEST = 'REMOVE_FROM_PLAYLIST_REQUEST';
const REMOVE_FROM_PLAYLIST_SUCCESS = 'REMOVE_FROM_PLAYLIST_SUCCESS';
const REMOVE_FROM_PLAYLIST_FAIL = 'REMOVE_FROM_PLAYLIST_FAIL';
const REMOVE_FROM_PLAYLIST_DETAILS_REQUEST =
  'REMOVE_FROM_PLAYLIST_DETAILS_REQUEST';
const REMOVE_FROM_PLAYLIST_DETAILS_SUCCESS =
  'REMOVE_FROM_PLAYLIST_DETAILS_SUCCESS';
const REMOVE_FROM_PLAYLIST_DETAILS_FAIL = 'REMOVE_FROM_PLAYLIST_DETAILS_FAIL';

export {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_SIGNUP_REQUEST,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAIL,
  LIKE_ADD_VIDEO_REQUEST,
  LIKE_ADD_VIDEO_SUCCESS,
  LIKE_ADD_VIDEO_FAIL,
  LIKE_REMOVE_VIDEO_REQUEST,
  LIKE_REMOVE_VIDEO_SUCCESS,
  LIKE_REMOVE_VIDEO_FAIL,
  LIKES_REQUEST,
  LIKES_SUCCESS,
  LIKES_FAIL,
  WATCHLATER_ADD_VIDEO_REQUEST,
  WATCHLATER_ADD_VIDEO_SUCCESS,
  WATCHLATER_ADD_VIDEO_FAIL,
  WATCHLATER_REMOVE_VIDEO_REQUEST,
  WATCHLATER_REMOVE_VIDEO_SUCCESS,
  WATCHLATER_REMOVE_VIDEO_FAIL,
  WATCHLATER_REQUEST,
  WATCHLATER_SUCCESS,
  WATCHLATER_FAIL,
  HISTORY_REQUEST,
  HISTORY_SUCCESS,
  HISTORY_FAIL,
  HISTORY_ADD_VIDEO_REQUEST,
  HISTORY_ADD_VIDEO_SUCCESS,
  HISTORY_ADD_VIDEO_FAIL,
  HISTORY_REMOVE_VIDEO_REQUEST,
  HISTORY_REMOVE_VIDEO_SUCCESS,
  HISTORY_REMOVE_VIDEO_FAIL,
  CLEAR_HISTORY_REQUEST,
  CLEAR_HISTORY_SUCCESS,
  CLEAR_HISTORY_FAIL,
  GET_PLAYLISTS_REQUEST,
  GET_PLAYLISTS_SUCCESS,
  GET_PLAYLISTS_FAIL,
  CREATE_PLAYLIST_REQUEST,
  CREATE_PLAYLIST_SUCCESS,
  CREATE_PLAYLIST_FAIL,
  DELETE_PLAYLIST_REQUEST,
  DELETE_PLAYLIST_SUCCESS,
  DELETE_PLAYLIST_FAIL,
  GET_PLAYLIST_DETAILS_REQUEST,
  GET_PLAYLIST_DETAILS_SUCCESS,
  GET_PLAYLIST_DETAILS_FAIL,
  ADD_TO_PLAYLIST_REQUEST,
  ADD_TO_PLAYLIST_SUCCESS,
  ADD_TO_PLAYLIST_FAIL,
  REMOVE_FROM_PLAYLIST_REQUEST,
  REMOVE_FROM_PLAYLIST_SUCCESS,
  REMOVE_FROM_PLAYLIST_FAIL,
  REMOVE_FROM_PLAYLIST_DETAILS_REQUEST,
  REMOVE_FROM_PLAYLIST_DETAILS_SUCCESS,
  REMOVE_FROM_PLAYLIST_DETAILS_FAIL,
};
